import React, { useState, useContext } from 'react';
import { Layout, Icon, Modal, Button, Space } from 'antd';
import store from 'store';
import { Navigate } from 'react-router-dom';
import { LogoutOutlined, MenuOutlined } from '@ant-design/icons';

import { LayoutContext, LanguageSwitcher } from '../contexts';

const { Header } = Layout;

function HeaderLayout({ isMobile }) {
  const { headerComponent, sideBarCollapsed, setCollapsed } = useContext(LayoutContext);

  const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
  const [isLogedOut, setLogedOut] = useState(false);

  const handleLogout = () => {
    store.set('authenticationToken', null);
    store.set('username', null);
    setLogedOut(true);
  };

  const handleMobileMenuToggle = () => {
    setCollapsed(!sideBarCollapsed);
  };

  return (
    <Header className="responsive-header">
      {isLogedOut && <Navigate to="/login" />}
      <div className="header-wrapper">
        <div className="header-left">
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={handleMobileMenuToggle}
              className="mobile-menu-button"
              size="large"
            />
          )}
          <div className="page-header">{headerComponent}</div>
        </div>
        <Space>
          <LanguageSwitcher size="small" />
          <LogoutOutlined
            type="logout"
            onClick={() => setLogoutModalOpen(true)}
            className="logout-icon"
          />
        </Space>
      </div>
      <Modal
        title="Log out from Menu Portal"
        open={isLogoutModalOpen}
        onOk={handleLogout}
        onCancel={() => setLogoutModalOpen(false)}
      >
        would you really like to log out?
      </Modal>
    </Header>
  );
}

export default HeaderLayout;
